var co = new Object; 
var getSelect = function (id) { 
  var s = document.getElementById(id); 
  return s.options[s.selectedIndex].value; 
} 

function recalc_onclick(ctl) { 
  co.weight=eeparseFloat(document.formc.weight.value); 
  co.height_ft=eeparseFloat(document.formc.height_ft.value); 
  co.height_in=eeparseFloat(document.formc.height_in.value); 
  co.gender=getSelect('gender'); 
  co.age=eeparseFloat(document.formc.age.value); 
  co.activity=getSelect('activity'); 
  
  calc(co); 
  
  document.formc.tdee.value=eedisplayFloat(co.tdee); 
  document.getElementById('div1').style.display = 'none'; 
  document.getElementById('div2').style.display = 'block'; 
  document.getElementById('email').style.display = 'block'; 
}; 

function reset_onclick() { 
  document.getElementById('div1').style.display = 'block'; 
  document.getElementById('div2').style.display = 'none'; 
  document.getElementById('email').style.display = 'none'; 
} 

var eeisus=1; 
var eetrue="TRUE"; 
var eefalse="FALSE"; 
var eedec="."; 
var eeth=","; 
var eedecreg=new RegExp("[.]","g"); 
var eethreg=new RegExp(",","g"); 

function calc(data){ 
  var weight=data.weight; 
  var height=data.height_ft*12+data.height_in; 
  var gender=data.gender; 
  var age=data.age; 
  var activity=data.activity; 
  var kg = weight * 0.453592; 
  var cm = height * 2.54; 
  var bmr = (10 * kg) + (6.25 * cm) - ( 5 * age) + 5; 
  
  if (gender == 'Female') 
    bmr = (10 * kg) + (6.25 * cm) - ( 5 * age) - 161; 
  
  data.tdee=round(bmr*activity,0); 
}; 

function str_eq(x,y){return(x.toLowerCase()==y.toLowerCase())}; 
function myIsNaN(x){return(isNaN(x)||(typeof x=='number'&&!isFinite(x)));}; 
function round(n,nd){if(isFinite(n)&&isFinite(nd)){var sign_n=(n<0)?-1:1;var abs_n=Math.abs(n);var factor=Math.pow(10,nd);return sign_n*Math.round(abs_n*factor)/factor;}else{return NaN;}}; 
function s2n(str){str=String(str).replace(eedecreg,".");return parseFloat(str);} 
function v2n(v){switch(typeof v){case "number":return v;case "string":return s2n(v);case "boolean":return v?1:0;case "object":if(v.constructor==Number){return v;};if(v.constructor==String){return s2n(v);};if(v.constructor==Boolean){return v?1:0;};return Number.NaN;default:return Number.NaN;}}; 
function eeparseFloat(str){str=String(str).replace(eedecreg,".");var res=parseFloat(str);if(isNaN(res)){return 0;}else{return res;}}; function eedisplayFloat(x){if(myIsNaN(x)){return Number.NaN;}else{return String(x).replace(/\./g,eedec);}}; 
function eedisplayFloatND(x,nd){if(myIsNaN(x)){return Number.NaN;}else{var res=round(x,nd);if(nd>0){var str=String(res);if(str.indexOf('e')!=-1)return str;if(str.indexOf('E')!=-1)return str;var parts=str.split('.');if(parts.length<2){var decimals=('00000000000000').substring(0,nd);return(parts[0]).toString()+eedec+decimals;}else{var decimals=((parts[1]).toString()+'00000000000000').substring(0,nd);return(parts[0]).toString()+eedec+decimals;}}else{return res;}}};var eeparseFloatVreg=new RegExp("^ *-?[0-9.]+ *$"); 
function eeparseFloatV(str){if(str=="")return str;str=String(str).replace(eedecreg,".");if(!eeparseFloatVreg.test(str)){return str;};var res=parseFloat(str);if(isNaN(res)){return str;}else{return res;}};
